import { BaseMapper } from '@ps/utils';
import {
  SurveyBuyerSettingsDto,
  SurveyBuyerSettingsVariableMappingItemDto,
} from '../../dtos/survey-buyer-settings.dto';
import {
  SurveyBuyerSettings,
  SurveyBuyerSettingsVariableMapping,
} from '../../../state/survey-state.model';

export class SurveyBuyerSettingsMapper extends BaseMapper<
  SurveyBuyerSettingsDto,
  SurveyBuyerSettings
> {
  public override fromDto(dto: SurveyBuyerSettingsDto): SurveyBuyerSettings {
    return {
      cmp: dto.cmp,
      companyName: dto.companyName,
      variableMapping: this._mapVariables(dto.variable_mapping),
      defaultCountryCode: dto.default_country,
      exclusionPeriodDefault: dto.exclusion_period_default,
    };
  }

  private _mapVariables(
    variableMapping: Array<
      Record<string, SurveyBuyerSettingsVariableMappingItemDto>
    >,
  ): SurveyBuyerSettingsVariableMapping[] {
    return variableMapping.flatMap((entry) =>
      Object.entries(entry).map(([key, value]) => ({
        key,
        outgoing: value.outgoing,
        incoming: value.incoming,
      })),
    );
  }
}
